// extracted by mini-css-extract-plugin
module.exports = {"txt":"Textarea_txt__h9LCE","txtTitle":"Textarea_txtTitle__NdQd9","txtContent":"Textarea_txtContent__t4AHN","full":"Textarea_full__ldXF7","error":"Textarea_error__z_vDn"};